"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _evergreenUi = require("evergreen-ui");
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// We’re not using Link because Evergreen restyles the links and we want EBI VF for that
// We also don’t like Evergreen’s Tooltip because  it doesn’t render HTML :(

var TooltipIcon = function TooltipIcon(_ref) {
  var tooltipText = _ref.tooltipText;
  return /*#__PURE__*/_react["default"].createElement("sup", null, /*#__PURE__*/_react["default"].createElement("span", {
    "data-tip": tooltipText,
    "data-html": true,
    className: "icon icon-generic",
    "data-icon": "i",
    style: {
      color: "lightgrey",
      fontSize: "small"
    }
  }));
};
TooltipIcon.propTypes = {
  tooltipText: _propTypes["default"].string.isRequired
};
var SelectionTableHeaderCell = function SelectionTableHeaderCell(_ref2) {
  var label = _ref2.label,
    selectedRowIds = _ref2.selectedRowIds,
    _onClick = _ref2.onClick,
    tooltipContent = _ref2.tooltipContent,
    width = _ref2.width;
  return /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.HeaderCell, {
    flexGrow: width,
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_evergreenUi.Heading, {
    size: 500
  }, selectedRowIds.length > 0 ? /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick() {
      return _onClick(selectedRowIds);
    }
  }, "".concat(label, " ").concat(selectedRowIds.length, " ").concat(selectedRowIds.length === 1 ? "entry" : "entries")) : label), tooltipContent && /*#__PURE__*/_react["default"].createElement(_evergreenUi.Pane, {
    paddingLeft: (0, _evergreenUi.majorScale)(1)
  }, /*#__PURE__*/_react["default"].createElement(TooltipIcon, {
    tooltipText: tooltipContent
  }), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    place: "left"
  })));
};
SelectionTableHeaderCell.propTypes = {
  label: _propTypes["default"].string.isRequired,
  selectedRowIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  onClick: _propTypes["default"].func,
  tooltipContent: _propTypes["default"].string,
  width: _propTypes["default"].number.isRequired
};
SelectionTableHeaderCell.defaultProps = {
  tooltipContent: "",
  width: 1,
  onClick: function onClick() {}
};
var _default = exports["default"] = SelectionTableHeaderCell;